import { useEffect } from "react";
import { Platform } from "react-native";
import {
  Audio,
  InterruptionModeAndroid,
  InterruptionModeIOS,
} from "expo-av";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

export default function AudioModeController() {
  const backgroundPlaybackEnabled = useSelector(
    (state: RootState) => state.playback.backgroundPlaybackEnabled,
  );

  useEffect(() => {
    if (Platform.OS === "web") {
      return;
    }

    Audio.setAudioModeAsync({
      allowsRecordingIOS: false,
      interruptionModeIOS: InterruptionModeIOS.DoNotMix,
      playsInSilentModeIOS: true,
      staysActiveInBackground: backgroundPlaybackEnabled,
      interruptionModeAndroid: InterruptionModeAndroid.DoNotMix,
      shouldDuckAndroid: false,
      playThroughEarpieceAndroid: false,
    }).catch((error) => {
      console.warn("Failed to update audio mode:", error);
    });
  }, [backgroundPlaybackEnabled]);

  return null;
}
